import { render, staticRenderFns } from "./JunoToken.vue?vue&type=template&id=745d388f&"
import script from "./JunoToken.vue?vue&type=script&lang=js&"
export * from "./JunoToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports